import Tabs from './utilities/tabs'
import RollableList from './utilities/rollableList'
import { isTouch, smoothScrollByElement } from './utilities/kdHelp'
import { Fancybox } from "@fancyapps/ui";
import Form from './utilities/form';
// import Preloader from './utilities/preloader';
import Inputmask from "inputmask";
import SlidePanel from './utilities/slidePanel';
import ButtonBurger from './utilities/buttonBurger';
import PartiallyHiddenList from './utilities/partiallyHiddenList';
import Splide from '@splidejs/splide';
import YandexMap from './utilities/yandexMap';
import Popup from './utilities/popup';
import Scrollbar from './utilities/scrollbar';
import { quizInit } from './utilities/quiz';

//  div(id="containerHide")
//      div(id="containerContent")
//          some content
function smoothInsert(containerHide, containerContent, elements) {
    if (!(containerHide && containerContent)) {
        console.error('bad parameters')
        return false
    }

    let currentHeight = containerContent.offsetHeight
    containerHide.style.height = currentHeight + ' px'

    elements.forEach(element => {
        containerContent.append(element)
    });
}

function showContentPart(container, count=4) {
    const children = Array.from(container.children)
    if (children <= count) return true

    children.forEach(element => {

    })
}

// handlers
window.Fancybox = Fancybox
window.smoothScrollHandler = (e)=>{
    e.preventDefault()

    const scrollTarget = document.getElementById( e.target.getAttribute('href').slice(1) )
    if (!scrollTarget) return

    smoothScrollByElement(scrollTarget, 100)
}

window.Inputmask = Inputmask

window.storage = {
    works: [7, 8, 9, 10, 11, 12, 13, 14, 15],
    forms: [],
    mounting: [
        {
            src: "./assets/files/Стоимость работ на установку изделий и облицовочные работы (монтаж).png",
        },
    ],
    workshopWork: [
        {
            src: "./assets/files/Стоимость работ на установку изделий и облицовочные работы (цеховые работы).png",
        },
    ],
    profileProcessing: [
        {
            src: "./assets/files/Стандартные виды профильной обработки изделий (стр 1).png",
            thumb: "./assets/files/Стандартные виды профильной обработки изделий (стр 1).png",
        },
        {
            src: "./assets/files/Стандартные виды профильной обработки изделий (стр 2).png",
            thumb: "./assets/files/Стандартные виды профильной обработки изделий (стр 2).png",
        },
        {
            src: "./assets/files/Стандартные виды профильной обработки изделий (стр 3).png",
            thumb: "./assets/files/Стандартные виды профильной обработки изделий (стр 3).png",
        },
    ],
}

window.shopGallery = (galleryId)=>{
    if ( !window.storage[galleryId] ) return

    window.Fancybox.show(window.storage[galleryId])
}

window.insertWorks = (triggerElement)=>{
    if ( !window.storage.works.length ) return false
    
    triggerElement.setAttribute('disabled', 'disabled')
    const insertedItems = window.storage.works.splice(0, 3).map((num) => {
        let numName = (num < 10) ? `0${num}` : `${num}`
        let item = document.createElement('li')
        item.classList.add('work__item')
        item.innerHTML = `
            <div class="work__card work-card"> 
                <div class="image-wrap work-card__image-wrap">
                    <a class="image-ratio work-card__image-ratio" data-fancybox="work" href="./assets/images/work-item-${numName}.jpg">
                        <img class="image work-card__image" src="./assets/images/work-item-${numName}-thumb.jpg">
                    </a>
                </div>
            </div>
            `
        return item
    })
    const worksContainerHide = document.getElementById('work-container-hide')
    const worksContainerContent = document.getElementById('work-container-content')
    smoothInsert(worksContainerHide, worksContainerContent, insertedItems)
    if ( window.storage.works.length ) {
        triggerElement.removeAttribute('disabled')
    }

}

window.showContentPartHandler = (triggerElement, elementId, count=4)=>{
    const container = document.getElementById(elementId)
    if (!container) return

    if ( showContentPart(container, count) ) {
        triggerElement.setAttribute('disabled', 'disabled')
    }
}

document.addEventListener('DOMContentLoaded', () => {

    // responsive window height
    let window_height_resize = ()=>{
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    }
    window.addEventListener('resize', window_height_resize);
    window_height_resize()

    // scrollbar
    new Scrollbar

    // popup
    window.popup = new Popup

    // quiz
    quizInit()

    // btn-burger
    window.storage.btnBurgers = {
        'btn-burger-nav': new ButtonBurger( document.getElementById('btn-burger-nav'), {class_prefix: 'btn-burger--'} )
    }

    // slide-panel
    window.storage.slidePanel = new SlidePanel( document.getElementById('slide-panel'), {
        class_prefix: 'slide-panel--'
    } )
    window.storage.slidePanel.addHandler( window.storage.btnBurgers['btn-burger-nav'].getElement() )
    window.storage.slidePanel.addEventListener('slidePanelBeforeChangeState', (e)=>{
        switch (e.detail.state) {
            case 'close':
                window.storage.btnBurgers['btn-burger-nav'].open()
                break;
            case 'open':
                window.storage.btnBurgers['btn-burger-nav'].close()
                break;
        
            default:
                break;
        }
    })

    // tabs
    window.tab = new Tabs( document.querySelector('[data-tab="handlers"]') )

    // rollable-list
    window.rollableList = new RollableList( document.querySelector('[data-rollable-list="container"]') )

    // forms
    const formElements = Array.from( document.querySelectorAll( '[data-form]' ) )
    window.storage.forms = formElements.map(formElement => new Form(formElement, {
        url: '/ajax/',
        action: 'leave_request',
        error_classname: 'form__error'
    }))

    // partiallyHiddenList
    const productsHiddenList = new PartiallyHiddenList( document.getElementById('products-container'), {
        hidingClass: 'products__item--hide',
        filterChildrenClass: 'products__item'
    })
    window.storage.productsHiddenList = productsHiddenList
    document.getElementById('btn-products-more').addEventListener('click', (e)=>{
        if (!productsHiddenList.showNext()) {
            e.target.setAttribute('disabled', 'disabled')
        }
    })

    // sliders
    const workSliderOptions = {
        type: 'loop',
        mediaQuery: 'max',
        perMove: 1,
        padding: {
            left: 0,
            right: 0,
        },
        classes: {
            page: 'splide__pagination-btn',
        },
        gap: 40,
        pagination: false,
        perPage: 4,
        focus: 0,
        breakpoints: {
            1023: {
                perPage: 3,
            },
            767: {
                gap: 18,
                perPage: 3,
            },
            639: {
                perPage: 2,
            },
            
        }
    }
    window.storage.slider = new Splide(document.getElementById('work-slider'), workSliderOptions)
    window.storage.slider.mount()

    // yandex map
    const ymap = new YandexMap
    const mapState = {
        center: [55.662583, 37.890512],
        zoom: 18,
        controls: ['zoomControl'],
    }
    const mapOptions = {
    }
    const placemark = {
        geometry: [55.662583, 37.890512]
        // geometry: [55.662253, 37.890481]
    }
    ymap.addMap(document.getElementById('map'), mapState, mapOptions)
    ymap.addPlacemarks([placemark])
    document.getElementById('map-no-scroll').addEventListener('click', (e)=>{
        e.target.style.display = 'none'
    })

    // video
    window.HELP_IMPROVE_VIDEOJS = false;
    const videoContainer = document.getElementById('video')
    const videoResource = videoContainer.querySelector('video')
    const videoPlay = videoContainer.querySelector('[data-element="video-play"]')
    
    // videoResource.addEventListener('play', (e)=>{
    //     videoContainer.classList.add('play')
    //     // videoResource.setAttribute('controls', '')
    // })
    // videoResource.addEventListener('pause', (e)=>{
    //     videoContainer.classList.remove('play')
    //     // videoResource.removeAttribute('controls')
    // })
    // videoResource.addEventListener('click', (e)=>{
    //     if (videoContainer.classList.contains('play')) {
    //         videoResource.pause()
    //     }
    // })
    // videoPlay.addEventListener('click', (e)=>{
    //     videoResource.play()
    // })
    videoPlay.style.display = 'none'
})
